import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
export function getBirthdayByIdCard(idCard) {
  var birthday = "";

  if (idCard != null && idCard != "") {
    if (idCard.length == 15) {
      birthday = "19" + idCard.substr(6, 6);
    } else if (idCard.length == 18) {
      birthday = idCard.substr(6, 8);
    }

    birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
  }

  return birthday;
}
export function getBirthdayByIdCardForDate(idCard) {
  var birthday = "";
  var birthdaate;

  if (idCard != null && idCard != "") {
    if (idCard.length == 15) {
      birthday = "19" + idCard.substr(6, 6);
    } else if (idCard.length == 18) {
      birthday = idCard.substr(6, 8);
    }

    birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
    var birthdayArr = birthday.split("-");
    birthdaate = new Date(birthdayArr[0], parseInt(birthdayArr[1]) - 1, parseInt(birthdayArr[2]));
  }

  return birthdaate;
}
export function GetAge(identityCard) {
  var len = (identityCard + "").length;

  if (len == 0) {
    return 0;
  } else {
    if (len != 15 && len != 18) //身份证号码只能为15位或18位其它不合法
      {
        return 0;
      }
  }

  var strBirthday = "";

  if (len == 18) //处理18位的身份证号码从号码中得到生日和性别代码
    {
      strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
    }

  if (len == 15) {
    strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
  } //时间字符串里，必须是“/”


  var birthDate = new Date(strBirthday);
  var nowDateTime = new Date();
  var age = nowDateTime.getFullYear() - birthDate.getFullYear(); //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1

  if (nowDateTime.getMonth() < birthDate.getMonth() || nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate()) {
    age--;
  }

  return age;
}
/**
 * 身份证保密显示
 * @author luotong
 * @date 2023/3/21 0021 14:58
 * @param null
 * @return null
 */

export function HideCardIdStr(str) {
  var len = str.length - 7;
  var xing = '';

  for (var i = 0; i < len; i++) {
    xing += '*';
  }

  return str.substring(0, 3) + xing + str.substring(str.length - 4);
}
/**
 * 身份证保密显示
 * @author luotong
 * @date 2023/3/21 0021 14:58
 * @param null
 * @return null
 */

export function HidePhoneStr(str) {
  var len = str.length - 7;
  var xing = '';

  for (var i = 0; i < len; i++) {
    xing += '*';
  }

  return str.substring(0, 7) + xing;
}
/**
 * 名字保密显示
 * @author ZLS
 * @date 2024/9/18
 * @param null
 * @return null
 */

export function hideName(str) {
  if (str == "") {
    return "";
  }

  var len = str.length - 1;
  var xing = '';

  for (var i = 0; i < len; i++) {
    xing += '*';
  }

  return xing + str.substring(str.length - 1);
} // 时间转化 yyyy-mm-dd hh:mm:ss

export function DateTimeConvert(time, type) {
  if (!type) {
    type = 'yyyy-mm-dd hh:mm:ss';
  }

  var d = time ? new Date(time) : new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hours = d.getHours();
  var min = d.getMinutes();
  var seconds = d.getSeconds();
  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  if (hours < 0) hours = '0' + hours;
  if (min < 10) min = '0' + min;
  if (seconds < 10) seconds = '0' + seconds;
  var res = "";

  switch (type) {
    case 'yyyy-mm-dd':
      res = year + '-' + month + '-' + day;
      break;

    case 'yyyy-mm-dd hh:mm':
      res = year + '-' + month + '-' + day + ' ' + hours + ':' + min;
      break;

    default:
      res = year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds;
      break;
  }

  return res;
}
export function isValidIDCard(idCard) {
  // 15位和18位身份证号码的正则表达式
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}[\dXx]$)/;
  return reg.test(idCard);
}